var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-right text-muted divider fn-sm"},[_vm._v(" 本島運費：購物滿 "),_c('b',{staticClass:"price spacing"},[_vm._v("$"+_vm._s(_vm.shipFareFreeLimit))]),_vm._v(" 元，免收運費 "),_c('b',{staticClass:"price spacing"},[_vm._v("$"+_vm._s(_vm.shipFare))]),_vm._v(" 元 "),_c('br'),_c('span',[_vm._v("(實付金額：需扣除優惠券、神腦幣)")])])
}
var staticRenderFns = []

export { render, staticRenderFns }